import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';
import { FormattedDate } from 'react-intl';
import Stars from 'react-stars';

import { SingleReputationFragment } from '../../../../graphql/generated/graphql_offer';
import { toJSDate } from '../../../../utility/graphql/datetime';
import { SPACING_UNIT } from '../../../constant/spacing';
import { flexibleLayoutContainer } from '../../../styleUtility/flexibleLayout';
import { gridLayoutContainer, gridLayoutItem } from '../../../styleUtility/gridLayout';
import AvatarWithName from '../../primitive/AvatarWithName';

interface Props extends ClassAttributes<HTMLElement> {
  reputation: SingleReputationFragment;
  refresh: () => void; // 使ってない
  className?: string;
}

const ReputationItem = ({ reputation, className }: Props) => (
  <Root className={className}>
    <UserWithActions>
      <AvatarWithName name={reputation.evaluator.name} imageUrl={reputation.evaluator.profileImageUrl} />
      <Score>
        <Stars edit={false} count={5} value={reputation.score} size={16} color2={'#1DA772'} />
      </Score>
    </UserWithActions>
    <Comment variant="body1">{reputation.comment}</Comment>
    <Date variant="caption">
      <FormattedDate
        value={toJSDate(reputation.updatedAt)}
        year="numeric"
        month="2-digit"
        day="2-digit"
        hour="2-digit"
        minute="2-digit"
      />
    </Date>
  </Root>
);

const Root = styled('div')(
  gridLayoutContainer({
    columns: ['100%'],
    rows: ['auto', 'auto', 'auto'],
    areas: [['userWithActions'], ['comment'], ['date']],
  }),
  {
    alignItems: 'center',
    paddingTop: SPACING_UNIT / 2,
    paddingBottom: SPACING_UNIT / 2,
  },
);

const UserWithActions = styled('div')(
  gridLayoutItem('userWithActions'),
  flexibleLayoutContainer({
    alignItems: 'center',
  }),
);

const Score = styled('div')(gridLayoutItem('score'), {
  marginLeft: SPACING_UNIT,
});

const Comment = styled(Typography)(gridLayoutItem('comment'), {
  marginTop: SPACING_UNIT,
  marginBottom: SPACING_UNIT / 2,
  overflowWrap: 'break-word',
  wordBreak: 'break-all',
});

const Date = styled(Typography)(gridLayoutItem('date'));

export default ReputationItem;
